<template>
  <div>
    <b-card no-body>
      <b-table
        id="threat-alerts-table"
        class="table-with-actions-min-height"
        responsive
        small
        primary-key="id"
        :items="alerts"
        :fields="tableFields"
        :per-page="perPage"
        :current-page="currentPage"
      >
        <template #cell(start)="row">
          <b-row>
            <b-col>
              {{ formatDate(row.value) }}
            </b-col>
          </b-row>
        </template>
        <template #cell(time)="row">
          <b-row>
            <b-col>
              {{ formatDate(row.value) }}
            </b-col>
          </b-row>
        </template>
         <template #cell(severity)="row">
          <b-badge pill :variant="alertStatusVariant(row.value)">
            {{ alertStatusText(row.value)}}
          </b-badge>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="paginationTotalRows"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
        align="right"
        class="mb-0 mt-1"
        ariaControls="threat-alerts-table"
      ></b-pagination>
    </b-card>
  </div>
</template>

<script>
import moment from 'moment';

import alertSeverities from '@/xvisor/constants/alertSeverities';
import colorPalette from '@/xvisor/constants/colorPalette';
import momentTimeFormat from '@/xvisor/constants/momentTimeFormat';

export default {
  props: {
    alerts: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      perPage: 5,
      currentPage: 1,
      tableFields: [
        { key: 'msg', label: 'Threat Info' },
        { key: 'start', label: 'Start Time', sortable: true },
        { key: 'time', label: 'End Time', sortable: true },
        { key: 'severity', label: 'Severity', sortable: true },
      ],
      colorPalette,
    };
  },
  computed: {
    paginationTotalRows() {
      return this.alerts.length;
    },
  },
  methods: {
    formatDate(dateStr) {
      return moment(dateStr).format(momentTimeFormat.dateTime);
    },
    alertStatusVariant(status) {
      if (status === alertSeverities.critical) return 'danger';
      if (status === alertSeverities.warning) return 'warning';
      return 'success';
    },
    alertStatusText(status) {
      if (status === alertSeverities.critical) return 'Critical';
      if (status === alertSeverities.warning) return 'Warning';
      return 'Notice';
    },
    colWidth(fieldKey) {
      switch (fieldKey) {
        case 'severity': return '10%';
        case 'start': return '10%';
        case 'time': return '10%';
        case 'alertInfo': return '35%';
        default: return '180px';
      }
    },
    colMinWidth(fieldKey) {
      switch (fieldKey) {
        case 'severity': return '100px';
        case 'start': return '100px';
        case 'time': return '100px';
        case 'alertInfo': return '300px';
        default: return '80px';
      }
    },
  },
};
</script>

<style scoped>
.custom-popover {
  max-width: 800px; /* Increase max-width */
  white-space: normal;
}

.popover-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px; /* Increase font size */
}

.popover-table th, .popover-table td {
  padding: 10px; /* Increase padding */
}

.popover-table th {
  font-weight: bold;
  font-size: 14px; /* Larger font size for headers */
}

.popover-entity-item:last-child td {
  border-bottom: none;
}
</style>
